import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Patient } from '../../../../core/models/patient/patient';
import { PatientAdvancedDirective } from '../../../../core/models/patient/patientAdvancedDirective';
import { CommonService } from '../../../../core/services/v2/common.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';
import { CodeTable } from '../../../../core/model/v2/code-table';

@Component({
  selector: 'app-patient-advanced-directive-edit',
  templateUrl: './patient-advanced-directive-edit.component.html',
  styleUrls: ['./patient-advanced-directive-edit.component.scss']
})
export class PatientAdvancedDirectiveEditComponent implements OnInit {

  @Input() advancedDirective: PatientAdvancedDirective;
  @Input() patientProfile: Patient;
  @Output() patientProfileChange = new EventEmitter<Patient>();
  @Output() toggleEvent = new EventEmitter();
  advancedDirectiveForm = new FormData();
  advancedDirectiveUrl: any;
  directiveCodes: CodeTable;
  userId: number;
  errorMessage: string;
  GuardianshipfileType: any;
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {

    this.userService.getUserDetails().subscribe(
      (res) => {
        this.userId = res.id;
      },
      (error) => { console.error(error); });

    this.advancedDirectiveUrl = this.advancedDirective && this.advancedDirective.documentLocation?this.advancedDirective.documentLocation:'';
    this.loadCodes()
  }


  loadCodes() {
    this.directiveCodes = this.commonService.getItemCodesFiltered('ADVANCEDDIRECTIVES');
  }

  attachDirective(event) {
    //this.loaderService.show();
    const file = event.target.files[0];
    this.GuardianshipfileType = file.type;
    this.advancedDirectiveForm.append('DocumentSource', file);
    const url = URL.createObjectURL(file);
    this.advancedDirectiveUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.advancedDirective.documentLocation = this.advancedDirectiveUrl;
    this.loaderService.hide();

  }

  updateDirective() {
    this.errorMessage = "";
    if (!this.advancedDirective.type || !this.advancedDirective.effectiveFrom)
      this.errorMessage = "Required fields should be filled";

    if (this.errorMessage.length > 0) return;

    this.loaderService.show();

    this.advancedDirectiveForm.append('PatientId', this.patientProfile && this.patientProfile.id ? this.patientProfile.id.toString() : this.advancedDirective.patientId.toString());
    if (this.advancedDirective.id)
      this.advancedDirectiveForm.append('Id', this.advancedDirective.id.toString());

    if (this.advancedDirective.type)
      this.advancedDirectiveForm.append('Type', this.advancedDirective.type);

    if (this.advancedDirective.effectiveFrom)
      this.advancedDirectiveForm.append('EffectiveFrom', this.datePipe.transform(this.advancedDirective.effectiveFrom, 'MM/dd/yyyy'));

    if (this.advancedDirective.effectiveTo)
      this.advancedDirectiveForm.append('EffectiveTo', this.datePipe.transform(this.advancedDirective.effectiveTo, 'MM/dd/yyyy'));

    this.advancedDirectiveForm.append('Active', 'true');

    this.patientService.updatePatientAdvancedDirective(this.advancedDirectiveForm).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.patientService.getCurrentPatientDetails().subscribe(
            (details) => {
              if (details) {
                this.patientProfile.patientAdvancedDirectives = details.patientAdvancedDirectives;
                this.patientProfileChange.emit(this.patientProfile);

              }
              this.toggleEvent.emit();
            },
            (error) => { console.error(error); },
            () => {
              this.loaderService.hide();
            }
          );
        } else
          console.error(res);
      },
      (error) => { console.error(error); },
      () => {
        this.loaderService.hide();
      }
    );

  }

  cancel() {
    this.toggleEvent.emit();
  }
}
